import { motion } from "framer-motion";
import { ArrowUpRight, Landmark, BookMarked, CalendarClock, Users, ListChecks } from "lucide-react";

const CARDS = [
  {
    id: "neo-lykeio",
    icon: Landmark,
    label: "Νέο Λύκειο",
    title: "Εθνικό Απολυτήριο & νέο σύστημα εισαγωγής στα ΑΕΙ",
    intro:
      "Το Υπουργείο Παιδείας σχεδιάζει το «Νέο Λύκειο» με θέσπιση Εθνικού Απολυτηρίου. Στόχος: το Λύκειο να αποκτήσει αυτόνομο παιδαγωγικό ρόλο και να μην είναι απλός προθάλαμος για τις Πανελλαδικές.",
    who: "Αφορά τους μαθητές που το 2026-27 φοιτούν στη Β' Γυμνασίου (Α' Λυκείου το 2027-28). Δεν αλλάζει τίποτα για τη σημερινή Γ' Λυκείου.",
    changes: [
      "Οι Πανελλαδικές δεν καταργούνται — ενσωματώνονται στο νέο σύστημα ως αδιάβλητος μηχανισμός.",
      "Συνυπολογισμός της επίδοσης και στις 3 τάξεις του Λυκείου (γραπτά & προφορικά) μαζί με τον βαθμό Πανελλαδικών.",
      "Εθνικό Απολυτήριο με προϋπόθεση τη βάση του 10 — σε αυτό θα βασίζεται η εισαγωγή στα ΑΕΙ.",
      "Τράπεζα Θεμάτων: σχέδιο για 100% των θεμάτων στις ενδοσχολικές εξετάσεις Α' & Β' Λυκείου.",
      "Εθνική Αρχή Εξετάσεων, Εθνικό Σώμα Αξιολογητών και συντελεστές βαρύτητας για τον βαθμό Απολυτηρίου.",
      "Δωρεάν κρατικά πιστοποιητικά (γλωσσομάθεια, ψηφιακές δεξιότητες) ενταγμένα στο Απολυτήριο.",
    ],
    timeline: [
      { when: "Φεβ 2026", what: "Έναρξη διαλόγου — Επιτροπή 106 μελών" },
      { when: "3 Σεπ 2026", what: "Ενδιάμεση Έκθεση της Επιτροπής" },
      { when: "Σεπ–Οκτ 2026", what: "Δημόσια διαβούλευση σε ηλεκτρονική πλατφόρμα" },
      { when: "Οκτ 2026", what: "Τελική έκθεση & χάρτης εφαρμογής" },
      { when: "2027-28", what: "Πρώτη εφαρμογή από την Α' Λυκείου" },
    ],
    link: { href: "https://www.minedu.gov.gr/", label: "Υπουργείο Παιδείας" },
    accent: "#0A1A4A",
  },
  {
    id: "nea-vivlia",
    icon: BookMarked,
    label: "Νέα Βιβλία",
    title: "Πολλαπλό Βιβλίο σε Γυμνάσιο & Λύκειο",
    intro:
      "Τέλος του «ενός βιβλίου»: για κάθε μάθημα εγκρίνονται περισσότερα διδακτικά πακέτα και οι εκπαιδευτικοί κάθε σχολείου επιλέγουν ποιο θα διδάξουν. Έχουν εγκριθεί 230 διδακτικά πακέτα (~440 βιβλία).",
    who: "Το 2026-27 τα σχολεία συνεχίζουν με τα υφιστάμενα βιβλία. Τα νέα βιβλία μπαίνουν στις τάξεις από τον Σεπτέμβριο 2027 (Γυμνάσιο & Α' Λυκείου).",
    changes: [
      "Η επιλογή βιβλίων από τους εκπαιδευτικούς ολοκληρώθηκε τον Ιούνιο 2026 (πλατφόρμα «Ορφέας»).",
      "Όλο το νέο υλικό είναι διαθέσιμο ψηφιακά στη βιβλιοθήκη «Μελίσπη» (ebooksdl.cti.gr) — PDF, ePUB και διαδραστικό υλικό.",
      "Έως 5 εναλλακτικά βιβλία σε μαθήματα όπως Χημεία Α' Λυκείου & Γεωλογία-Γεωγραφία Α' Γυμνασίου.",
      "Σε αρκετά μαθήματα (π.χ. Ιστορία Γυμνασίου, Βιολογία Α' Λυκείου) υπάρχει προς το παρόν ένα εγκεκριμένο βιβλίο.",
      "Νέα πρόσκληση ΙΕΠ για μαθήματα με ελλιπή κάλυψη (ξένες γλώσσες, Καλλιτεχνικά, Μουσική, Φυσική Αγωγή).",
    ],
    timeline: [
      { when: "Ιουν 2026", what: "Επιλογή βιβλίων από τα σχολεία" },
      { when: "2026-27", what: "Υφιστάμενα βιβλία σε όλες τις τάξεις" },
      { when: "Σεπ 2027", what: "Νέα βιβλία: Δημοτικό, Γυμνάσιο, Α' Λυκείου" },
      { when: "2028-29", what: "Νέα βιβλία Β' Λυκείου" },
      { when: "2029-30", what: "Νέα βιβλία Γ' Λυκείου" },
    ],
    link: { href: "https://www.iep.edu.gr/pollaplo-vivlio/", label: "ΙΕΠ — Πολλαπλό Βιβλίο & Μελίσπη" },
    accent: "#B45309",
  },
];

function ReformCard({ c, i }) {
  const Icon = c.icon;
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: i * 0.1 }}
      data-testid={`reform-card-${c.id}`}
      className="flex flex-col bg-white border border-border rounded-sm overflow-hidden"
    >
      <div className="p-6 md:p-8 border-b border-border" style={{ borderTop: `4px solid ${c.accent}` }}>
        <div className="flex items-center justify-between mb-4">
          <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em]" style={{ color: c.accent }}>// {c.label}</span>
          <Icon className="h-6 w-6" strokeWidth={1.5} style={{ color: c.accent }} />
        </div>
        <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug">{c.title}</h3>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{c.intro}</p>
      </div>

      <div className="p-6 md:p-8 grid md:grid-cols-5 gap-8 flex-1">
        <div className="md:col-span-3">
          <div className="flex items-center gap-2 font-mono-accent text-[10px] uppercase tracking-widest text-muted-foreground mb-3"><ListChecks className="h-3.5 w-3.5" /> Τι αλλάζει</div>
          <ul className="space-y-2.5">
            {c.changes.map((t, j) => (
              <li key={j} className="flex gap-3 text-sm leading-relaxed">
                <span className="mt-2 h-1.5 w-1.5 rounded-full shrink-0" style={{ background: c.accent }} />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 font-mono-accent text-[10px] uppercase tracking-widest text-muted-foreground mb-3"><CalendarClock className="h-3.5 w-3.5" /> Χρονοδιάγραμμα</div>
          <ol className="relative border-l border-border ml-1.5">
            {c.timeline.map((t, j) => (
              <li key={j} className="pl-4 pb-4 last:pb-0 relative">
                <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full border-2 border-white" style={{ background: c.accent }} />
                <div className="font-mono-accent text-[10px] uppercase tracking-widest" style={{ color: c.accent }}>{t.when}</div>
                <div className="text-sm leading-snug">{t.what}</div>
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div className="px-6 md:px-8 py-5 bg-secondary/50 border-t border-border flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <p className="flex gap-2 text-xs text-muted-foreground leading-relaxed"><Users className="h-4 w-4 shrink-0 mt-0.5" /> {c.who}</p>
        <a
          data-testid={`reform-link-${c.id}`}
          href={c.link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1.5 shrink-0 font-mono-accent text-[10px] uppercase tracking-widest text-primary hover:underline"
        >
          {c.link.label} <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </motion.article>
  );
}

export default function EduReforms() {
  return (
    <section id="reforms" data-testid="reforms-section" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Τι αλλάζει στο σχολείο</div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
            Νέο Λύκειο & νέα βιβλία — όσα πρέπει να ξέρουν γονείς και μαθητές.
          </h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Οι δύο μεγάλες μεταρρυθμίσεις της δευτεροβάθμιας εκπαίδευσης, με απλά λόγια: ποιους αφορούν, τι αλλάζει και πότε. Ενημέρωση: Σεπτέμβριος 2026 — το Νέο Λύκειο βρίσκεται ακόμη σε διαβούλευση.
          </p>
        </div>
        <div className="grid lg:grid-cols-2 gap-6">
          {CARDS.map((c, i) => <ReformCard key={c.id} c={c} i={i} />)}
        </div>
      </div>
    </section>
  );
}
